import LatestNews from "./LatestNews";

const UpcomingEvents = () => {
  return (
    <section className="ftco-section ftco-no-pb">
<div className="container">
<div className="row justify-content-center pb-4">
    <div className="col-md-12  heading-section ftco-animate text px-4">
      <h2 className="mb-4 text-success text-center">
        Upcoming Events
      </h2>   
    </div>
  </div>
    
  <div className="row mt-3">
    <div className=" col-md-12 order-md-first">
      <div className="text px-4">
    
                          <p>  We are excited to announce the upcoming events for this academic year! These events aim to provide students with opportunities for learning, creativity, leadership, and fun. </p>
              <LatestNews />
              <p>We invite all students, parents, and staff to participate and make these events successful and memorable! Stay tuned for more updates.</p>
                          
        </div>
    </div>

  
  </div>  
  </div>
  {/* <hr className="custom-hr"/> */}
    </section>
  );
};

export default UpcomingEvents;
